import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
// import { Link } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';
import { HashLink } from 'react-router-hash-link';
import crop1 from '../images/crop1.jpg';
import AnimatedText from './AnimatedText';

const Hero = () => {
    return (
        <>
                <div className="hero" id="hero">
  <div>
    <NavBar />
  </div>

  <div className="overflow-hidden mx-4 mt-10 lg:mt-10 px-2 md:p-12 h-full" data-aos="zoom-in">
    <div className="flex lg:justify-center items-center w-full lg:w-full" data-aos="fade-up" data-aos-delay="700">
      <div id="hero" className="flex flex-col lg:flex-row lg:mx-4 mx-7 lg:my-28 my-20 py-5 justify-center text-center lg:text-center">
        <div className="lg:w-1/2 flex flex-col" data-aos="zoom-in" data-aos-delay="200">
          <h1 className="md:text-2xl text-xl font-bold text-gray-600 dark:text-gray-300">Welcome!</h1>
          <h1 className="py-5 md:text-3xl text-2xl font-bold text-[#b54a73]">👋 I’m Hilina Mulugeta,</h1>

          <div className="flex justify-center mb-5">
            <img
              alt="Hilina Mulugeta"
              className="rounded-full my-5 w-72 h-72 sm:w-80 sm:h-80 md:w-96 md:h-96 lg:w-96 lg:h-96 object-cover"
              src={crop1}
            />
          </div>

          <div className="py-5 md:text-3xl text-2xl font-bold text-[#b06481dd]">
            <AnimatedText />
          </div>

          <div className="text-lg font-semibold tracking-tight mb-5 text-gray-500 dark:text-gray-300">
            My expertise covers frontend web development, Agile methodology (as a Scrum master) by using modern technologies like React.Js, Vue.Js, Next.js, and Jira.
            Explore to learn more about my journey, skills, and the portfolios I've worked on.
          </div>

          <div className="mb-4 space-x-0 md:space-x-2 md:mb-8">
            <HashLink
              className="text-white bg-[#e4a6bd] hover:bg-[#b54a73] inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0"
              smooth
              to="/#contact"
            >
              Learn more
              <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
              </svg>
            </HashLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

        </>
        
    )
}

export default Hero;